var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"copy-field",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"url",attrs:{"id":"share-url","value":_vm.url,"width":"250px","append-outer-icon":"mdi-content-copy"},on:{"click":_vm.copyPath,"click:append-outer":_vm.copyPath}},on))]}}])},[_c('span',[_vm._v("Copy")])])}
var staticRenderFns = []

export { render, staticRenderFns }